import React from 'react';

import ImageLink from './ImageLink';

import ConfigPropMapService from '../../../../Shared/services/configPropMapService';
import ConfigPropId from '../../../../Shared/constants/configPropId';
import NavigationTokens from '../../../../Shared/constants/navigationTokens';
import NavTokenMapService from '../../../../Shared/services/navTokenMapService';

class TopRow extends React.PureComponent {
    retrieveBaseNavLink(navTokenName) {
        return NavTokenMapService.getNavToken(navTokenName).url;
    }

    getTrackDelivery() {
        let isDashboardEnabled = ConfigPropMapService.getConfigPropbyId(ConfigPropId.EnableDashboard).value;
        let token = isDashboardEnabled ? this.retrieveBaseNavLink(NavigationTokens.Dashboard)
            : this.retrieveBaseNavLink(NavigationTokens.OrderHistory);

        let imageLink = "ClientApps/Assets/Images/ContactUs/contactus-trackapackage.png";

        return <React.Fragment>
            <ImageLink
                url={token}
                imageSrc={imageLink}
                altText="Track a Package"
                CSRRepTitle={this.props.CSRRepTitle}
                featureActive
            > 
                Track a Package
            </ImageLink>
            <div className="icon-divider" />
        </React.Fragment>;
    }

    getStartReturn() {
        let onlineReturnsAllowed = ConfigPropMapService.getConfigPropbyId(ConfigPropId.PermitOnlineReturns).value;
        let token = this.retrieveBaseNavLink(NavigationTokens.ReturnCenter);
        let imageLink = "ClientApps/Assets/Images/ContactUs/contactus-startareturn.png";

        return <React.Fragment>
            <ImageLink
                url={token}
                imageSrc={imageLink}
                altText="Start a Return"
                featureActive={onlineReturnsAllowed}
                CSRRepTitle={this.props.CSRRepTitle}
                enablePopup
             >
                Start a Return
            </ImageLink>
            <div className="icon-divider" />

        </React.Fragment>;
    }

    getUpdateAccount() {
        let token = this.retrieveBaseNavLink(NavigationTokens.MyAccount);
        let imageLink = "ClientApps/Assets/Images/ContactUs/contactus-updateaccount.png";

        return <React.Fragment>
            <ImageLink
                url={token}
                imageSrc={imageLink}
                altText="Update Account"
                CSRRepTitle={this.props.CSRRepTitle}
                featureActive
                enablePopup
            >
                Update Account
            </ImageLink>
            <div className="icon-divider" />
        </React.Fragment>;
    }

    getFullMyWbLink(baseUrl) {
        var defaultSortOrderSearch = ConfigPropMapService.getConfigPropbyId(ConfigPropId.DefaultSortOrderMyWB).value;

        let requiredParams = {
            sortCode: "sc",
            firstIndex: "fi",
            firstResult: "fr"
        };

        return `${baseUrl}?` +
            `${requiredParams.sortCode}=${defaultSortOrderSearch}` +
            `&${requiredParams.firstIndex}=1` +
            `&${requiredParams.firstResult}=1`;
    }

    renderPayABill() {
        let token = this.retrieveBaseNavLink(NavigationTokens.AccountStatement);
        let imageLink = "ClientApps/Assets/Images/ContactUs/contactus-payabill.svg";

        return <React.Fragment>
            <ImageLink
                url={token}
                imageSrc={imageLink}
                altText="Pay A Bill"
                CSRRepTitle={this.props.CSRRepTitle}
                featureActive
                enablePopup
                isSVG={true}
            >
                Pay a Bill
            </ImageLink>
            <div className="icon-divider" />
        </React.Fragment>;
    }

    getReorderProduct() {
        let myWBRecentItemsToken = this.retrieveBaseNavLink(NavigationTokens.MyWBRecentItems);
        let MyWBContactUsImage = ConfigPropMapService.getConfigPropbyId(ConfigPropId.MyWBContactUsImage).value;
        
        let isMyWBRecentItemsEnabled = ConfigPropMapService.getConfigPropbyId(ConfigPropId.EnableMyWBRecentItemsPage).value;

        return <React.Fragment>
            <ImageLink
                url={this.getFullMyWbLink(myWBRecentItemsToken)}
                imageSrc={MyWBContactUsImage}
                altText="MyWB Logo"
                featureActive={isMyWBRecentItemsEnabled}
                CSRRepTitle={this.props.CSRRepTitle}
                enablePopup
                imgWidth="250"
                imgHeight="82"
            >
            Reorder Product
            </ImageLink>
            <div className="icon-divider" />
        </React.Fragment>;
    }

    render() {
        return (
            <React.Fragment>
                {this.getTrackDelivery()}
                {this.getStartReturn()}
                {this.getUpdateAccount()}
                {this.renderPayABill()}
                {this.getReorderProduct()}
            </React.Fragment>);
    }
}
export default TopRow;
